import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './members/login/login.component';
import { HomeComponent } from './public/home/home.component';
import { CguComponent } from './public/cgu/cgu.component';
import { ConnexionComponent } from './public/connexion/connexion.component';
import { MaterialModule } from './material.module';
import { FirebaseAuthService } from './services/firebase-auth.service';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireFunctionsModule, REGION } from '@angular/fire/functions';
import { environment } from 'src/environment';
import { LayoutComponentModule } from './members/layout/layout.component.module';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    CguComponent,
    ConnexionComponent 
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireFunctionsModule,
    LayoutComponentModule
  ],
  providers: [
    FirebaseAuthService,
    { provide: REGION , useValue: 'europe-west1' },
  ],
  exports: [
    MaterialModule
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
